'use strict';

var _ = require('lodash');
var ProfileChartDirective = function ProfileChartDirective(Chart, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart.html'),
    controller: 'ProfileChartController',
    scope: {
      screen: '@',
      mode: '@',
      subMode: '@',
      brushFilterType: '@',
      target: '@',
      visible: '=',
      metrics: '=',
      showCapacity: '@',
      selectedService: '=?',
      chartExpandable: '@',
      primaryEntity: '=',
      screenState: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        scope.$emit('reload-carousel');
        if (scope.visible) {
          chart.withMetric(scope.metrics.selectedMetric.label).render(data);
        }
      };
      chart.on('pindown', scope.handlePinDown);
      scope.setSelectedDtd = function (dtd) {
        chart.setSelectedDtd(dtd);
      };
      scope.reloadIfVisible = function (invokeApply) {
        if (scope.visible) {
          scope.timeoutReload(invokeApply);
        }
      };
      scope.timeoutReload = function (invokeApply) {
        if (scope.timeoutPromise) {
          $timeout.cancel(scope.timeoutPromise);
        }
        scope.timeoutPromise = $timeout(scope.initChart, 0, invokeApply);
      };
      scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
        if (mode === 'market-product-group') {
          scope.resetFilters();
          scope.reloadIfVisible(false);
        }
      });
      scope.$on('brush-filter:filterApplied', function (event, brushFilter) {
        if (brushFilter.filterType === 'profileChart') {
          return;
        }
        scope.reloadIfVisible();
      });
      scope.$on('class-mix-graph:close-broadcast', function () {
        scope.reloadIfVisible();
      });
      scope.$watch('visible', function () {
        scope.reloadIfVisible();
      });
      scope.$watch('screenState.selectedReference', function () {
        if (_.get(scope, ['screenState', 'searchReady'])) {
          scope.reloadIfVisible();
        }
      });
    }
  };
};
ProfileChartDirective.$inject = ['ProfileChart', '$timeout'];
module.exports = ProfileChartDirective;